export default [
  { icon: 'mdi-information', title: 'Detail Akun', event: 'onDetail' },
  {
    icon: 'mdi-account-multiple-check',
    title: 'Set Peserta Diklat',
    event: 'onSetPeserta',
    akses: 'psp-pip-diklat.create',
  },
  {
    icon: 'mdi-pencil',
    title: 'Ubah Status',
    event: 'onSetStatus',
    akses: 'psp-pip-profil.save-mundur',
  },
  {
    icon: 'mdi-account-multiple-remove',
    title: 'Batalkan Peserta Diklat',
    event: 'onDeletePeserta',
    akses: 'psp-pip-diklat.delete',
  },
  { icon: 'mdi-email', title: 'Kirim Ulang Aktivasi', event: 'onAktivasi', akses: 'psp-pip-profil.resend-email' },
  { divider: ['psp-pip-profil.delete'] },
  { icon: 'mdi-delete', title: 'Hapus Akun', event: 'onDelete', akses: 'psp-pip-profil.delete' },
];
